module.exports = __webpack_public_path__ + "static/media/markerLocation.aab82240.svg";